<template>
  <v-form class="pa-6">
    <h3 class="text-left mb-1 text-primary">Add certificate (<span v-html="serverConfig?.credential?.id"></span>)</h3>
    <p class="text-caption mb-4">Generá el CSR e instalá el certificado (pkcs7) en la credencial.</p>
    <div class="d-flex ga-2 mb-6">
      <v-btn
        size="small"
        color="primary"
        @click="generateCSR">
        Generate CSR
      </v-btn>
      <v-btn
        size="small"
        :disabled="localpkcs7 == ''"
        color="primary"
        @click="installCertificate">
        Install Certificate >>
      </v-btn>
    </div>
    <v-row>
      <v-col md="6">
        <v-textarea
          v-model="localcsr"
          no-resize
          height="240"
          label="CSR">
        </v-textarea>
      </v-col>
      <v-col md="6">
        <v-textarea
          v-model="localpkcs7"
          no-resize
          height="240"
          label="pkcs7">
        </v-textarea>
      </v-col>
    </v-row>
  </v-form>
</template>
<script>
import { mapMutations } from 'vuex';
import alisonServer from  '../services/alisonServer.js';
  export default {
    props:["data", "config", "serverConfig", "pkcs7"],
    data: () => ({
      localcsr: '',
      localpkcs7: '',
    }),
    mounted(){
      this.localcsr = this.csr;
      if (this.pkcs7 == null)
        return
      let concat = "-----BEGIN PKCS7-----\n";
      for (let i = 0; i < this.pkcs7.length; i++) {
        concat += this.pkcs7.charCodeAt(i) === 10 ? "\n" : this.pkcs7.charAt(i)
      }
      concat += "\n-----END PKCS7-----";
      this.localpkcs7 = concat;
    },
    watch:{
      pkcs7(newValue) {
        this.localpkcs7 = newValue;
      },
      csr(newValue) {
        this.localcsr = newValue;
      }
    },
    methods: {
      ...mapMutations({
        setSnack: 'setSnack',
        setColor: 'setColor'
      }),

      async generateCSR() {
        try {
          let { csr } = await alisonServer.generateCSR(this.serverConfig.seatId, this.serverConfig.credential.id);
          csr = `-----BEGIN CERTIFICATE REQUEST-----\n${csr}-----END CERTIFICATE REQUEST-----`;
          this.localcsr = csr;
          this.$emit("setCSR", csr);
        } catch (e) {
          console.log(e);
          this.setColor("error");
          this.setSnack(e);
        }

      },

      async installCertificate() {
        try {
          await alisonServer.installCertificate(this.localpkcs7, this.serverConfig.seatId, this.serverConfig.credential.id);
          this.setColor("success");
          this.setSnack("Certificate added to credential " + this.serverConfig.credential.id);
        } catch (e) {
          console.log(e);
          this.setColor("error");
          this.setSnack(e);
        }
      }
    },
  }
</script>
